module.exports = ".center {\n  margin: auto;\n  width: 75px;\n  padding: 10px; }\n"